import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import AudioPlayer from 'components/application/AudioPlayer';
import SendUserbar from 'components/application/SendUserbar';
import I18n from 'helpers/I18n';

class TestResults extends React.Component {
  static propTypes = {
    sendUserbarURL:       React.PropTypes.string.isRequired,
    sendUserbarMethod:    React.PropTypes.oneOf(["POST"]).isRequired,
    backURL:              React.PropTypes.string.isRequired,
    uuid:                 React.PropTypes.string.isRequired,
    questions:            React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    answers:              React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    score:                React.PropTypes.number.isRequired,
    totalQuestions:       React.PropTypes.number.isRequired,
    userbarToken:         React.PropTypes.string,
    topicId:              React.PropTypes.number.isRequired,
  }

  state = {
    currentPlayingQuestionId: undefined,
  }

  handlePlay = (questionId) => {
    this.setState({ currentPlayingQuestionId: questionId });
  }

  handlePause = (questionId) => {
    if (questionId === this.state.currentPlayingQuestionId) {
      this.setState({ currentPlayingQuestionId: null });
    }
  }

  render() {
    const answersByQuestionId = _.reduce(this.props.answers, (r, a) => {
      r[a.question_id] = a;
      return r;
    }, {});

    const questionResults = this.props.questions.map((q, i) => {
      return (
        <div className="col-md-6" key={q.id}>
          <TestResults.QuestionResult number={i + 1}
                                      question={q}
                                      selectedAnswerId={answersByQuestionId[q.id].selected_answer_id}
                                      correctAnswerId={answersByQuestionId[q.id].correct_answer_id}
                                      isPlaying={q.id === this.state.currentPlayingQuestionId}
                                      onPlay={this.handlePlay}
                                      onPause={this.handlePause}/>
        </div>
      );
    });

    const questionResultPairs = [];
    questionResults.forEach((qr, i) => {
      if (i % 2 == 0) {
        const pair = [qr];
        questionResultPairs.push(pair);
      } else {
        questionResultPairs[questionResultPairs.length - 1].push(qr);
      }
    }, this);

    const rows = questionResultPairs.map((qrPair, i) => <div className="row" key={i}>{qrPair}</div>, this);

    return (
      <div>
        <div className="page-header">
          <h1 className="m-b-0">{I18n.t("test_results.title")}</h1>
        </div>
        <h2 className="p-t-15">{`${I18n.t("test_results.score")}: ${this.props.score}/${this.props.totalQuestions}`}</h2>

        <TestResults.PublicURL uuid={this.props.uuid}></TestResults.PublicURL>

        <SendUserbar userbarToken={this.props.userbarToken}
                     submitURL={this.props.sendUserbarURL}
                     submitMethod={this.props.sendUserbarMethod}/>
        <div className="form">
          {rows}
        </div>
        <ul className="list-inline p-t-20 p-b-20">
          <li><a href={`/tests/new?topic_id=${this.props.topicId}`}>{I18n.t("test_results.another")}</a></li>
          <li><a href={this.props.backURL}>{I18n.t("test_results.back")}</a></li>
        </ul>
      </div>
    );
  }
}

class TestResultsQuestionResult extends React.Component {
  static propTypes = {
    number:                 React.PropTypes.number.isRequired,
    question:               React.PropTypes.object.isRequired,
    selectedAnswerId:       React.PropTypes.number,
    correctAnswerId:        React.PropTypes.number,
    isPlaying:              React.PropTypes.bool.isRequired,
    onPlay:                 React.PropTypes.func.isRequired,
    onPause:                React.PropTypes.func.isRequired,
  }

  handlePlay = () => {
    this.props.onPlay(this.props.question.id);
  }

  handlePause = () => {
    this.props.onPause(this.props.question.id);
  }

  answerClassNames(ao) {
    return classNames("answer", {
      "correct":    this.isCorrect(ao),
      "incorrect":  !this.isCorrect(ao),
      "submitted":  this.isChosen(ao),
    });
  }

  isCorrect(ao) {
    return ao.id === this.props.correctAnswerId;
  }

  isChosen(ao) {
    return ao.id === this.props.selectedAnswerId;
  }

  answerNote(ao) {
    if (this.isCorrect(ao)) {
      return(<span className="text-success">{` \u2013 ${I18n.t("test_results.is_correct_answer")}`}</span>);
    } else if (this.isChosen(ao)) {
      return(<span className="text-danger">{` \u2013 ${I18n.t("test_results.is_selected_answer")}`}</span>);
    }
  }

  render() {
    let audio;
    if (this.props.question.audio_url) {
      audio = <AudioPlayer preload={false}
                           audioURL={this.props.question.audio_url}
                           isPlaying={this.props.isPlaying}
                           onPlay={this.handlePlay}
                           onPause={this.handlePause}/>;
    }
    const radios = this.props.question.answer_options.map(ao => {
      return <span key={ao.id} className="radio">
        <label className={this.answerClassNames(ao)}>
          <input name={this.props.question.id}
                 type="radio"
                 checked={this.isChosen(ao)}
                 disabled={true}
                 onChange={this.handleSelectedAnswerChange}/>
          <span className="radio-label">
            {ao.text}
            {this.answerNote(ao)}
          </span>
        </label>
      </span>
    });
    return (
      <div className="question">
        <h3 className={classNames({ "incorrect": this.props.correctAnswerId != this.props.selectedAnswerId })}>
          {`${I18n.t("test_results.question")} ${this.props.number}`}
        </h3>
        <p className="p-t-5">{this.props.question.text}</p>
        {audio}
        <div>
          {radios}
        </div>
      </div>
    );
  }
}

class TestResultsPublicURL extends React.Component {
  static propTypes = {
    uuid: React.PropTypes.string.isRequired,
  }

  handleClicked = (e) => {
    e.target.select();
  }

  render() {
    return (
      <form className="test-public-result form-inline p-t-15 p-b-20">
        <h4>{I18n.t("test_results.public_url")}</h4>
        <input type="text"
               className="form-control"
               readOnly={true}
               size="80"
               onClick={this.handleClicked}
               value={Routes.testResultPreviewURL(this.props.uuid)}/>
      </form>
    );
  }
}

TestResults.QuestionResult = TestResultsQuestionResult;
TestResults.PublicURL = TestResultsPublicURL;
export default TestResults;



// WEBPACK FOOTER //
// ./app/javascript/components/application/TestResults.jsx